import { BaseDto } from './base.dto';
import { EntityTypeDto } from './entityType.dto';
import { MerchantDto } from './merchant.dto';
import { PrintConfigurationConditionDto } from './printConfigurationCondition.dto';
import { PrintConfigurationEntityFilteringValueDto } from './printConfigurationEntityFilteringValue.dto';
import { PrintConfigurationMerchantPrinterDto } from './printConfigurationMerchantPrinter.dto';
import { PrintConfigurationTemplateSectionSettingDto } from './printConfigurationTemplateSectionSetting.dto';
import { PrintTemplateDto } from './printTemplate.dto';

export enum PrintConditionsMode {
    ANY = 0,
    ALL_MATCH = 1
}
export class PrintConfigurationDto extends BaseDto{

    name: string;


    merchant: MerchantDto;

   
    
    printConditionsMode: PrintConditionsMode;

    entityType: EntityTypeDto;

    enabled: boolean;

    isDefault?: boolean;
    
    isCategoryNameSeparator?: boolean;

    printTemplate: PrintTemplateDto;

    metadata?: any;

    printTemplateSectionSettings?: PrintConfigurationTemplateSectionSettingDto[];


    filteringOptions?: PrintConfigurationEntityFilteringValueDto[];


    conditions?: PrintConfigurationConditionDto[];


    printerConfigurations?: PrintConfigurationMerchantPrinterDto[];
}